const button01 = document.getElementById('button01');
const button02 = document.getElementById('button02');
const resultImageBox = document.querySelectorAll('.result-image-box');
const orientationForm = document.getElementById('form-orientation');
const radioOrientation = document.form_orientation.orientation;
const httpRequest = new XMLHttpRequest();
const fileInput = [];
fileInput[0] = document.getElementById('original-image1');
fileInput[1] = document.getElementById('original-image2');
fileInput[2] = document.getElementById('original-image3');
fileInput[3] = document.getElementById('original-image4');
const imgPreview = [];
imgPreview[0] = document.getElementById('preview1');
imgPreview[1] = document.getElementById('preview2');
imgPreview[2] = document.getElementById('preview3');
imgPreview[3] = document.getElementById('preview4');
const resultImageSize = document.getElementById('result-image-size');
const loadingArea = [];
loadingArea[0] = document.getElementById('loading-area1');
loadingArea[1] = document.getElementById('loading-area2');
loadingArea[2] = document.getElementById('loading-area3');
loadingArea[3] = document.getElementById('loading-area4');
const loading = [];
loading[0] = document.getElementById('loading1');
loading[1] = document.getElementById('loading2');
loading[2] = document.getElementById('loading3');
loading[3] = document.getElementById('loading4');
const resultLoadingArea = document.querySelectorAll('.result-loading-area');
const resultLoading = document.querySelectorAll('.result-loading');
const vcType = 'vc2';
const numFilesToUpload = 4;
const seed = 1;
let random;
const shorterEdgeRatio = 200 / 277;
let maxLongerEdge = 200;
let baseWidth = 130;
let baseHeight = 180;
const scale = 5;

const urlRoot = Shopify.routes.root;
const linkUrlBase = `${urlRoot}products/vc2`

const presignedUrlEndpoint = "https://7gjadx2yr7cy6y2veinrcw6mnq0ecujz.lambda-url.ap-northeast-1.on.aws/"

button02.addEventListener('click', getPresignedUrl);
resultImageSize.addEventListener('change', resetSize);
orientationForm.addEventListener('change', resetSize);

const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');

const jimpImages = [null, null, null, null];
let firstTime = true;

const resultDataList = [null, null, null];

const resultImagePreview = document.querySelectorAll('.result-image-preview');
const resultImagePreview1 = document.getElementById('result-image-preview1');
const resultImagePreview2 = document.getElementById('result-image-preview2');
const resultImagePreview3 = document.getElementById('result-image-preview3');
const resultImagePreview4 = document.getElementById('result-image-preview4');
fileInput[0].addEventListener('change', {target: 0, handleEvent: loadImage}); 
fileInput[1].addEventListener('change', {target: 1, handleEvent: loadImage}); 
fileInput[2].addEventListener('change', {target: 2, handleEvent: loadImage}); 
fileInput[3].addEventListener('change', {target: 3, handleEvent: loadImage}); 

let leftTopMarker = marker(true);
let rightDownMarker = marker(false);

class Random {
  constructor(seed = 88675123) {
    this.x = 123456789;
    this.y = 362436069;
    this.z = 521288629;
    this.w = seed;
  }
  
  // XorShift
  next() {
    let t;
 
    t = this.x ^ (this.x << 11);
    this.x = this.y; this.y = this.z; this.z = this.w;
    return this.w = (this.w ^ (this.w >>> 19)) ^ (t ^ (t >>> 8)); 
  }
  
  // min以上max以下の乱数を生成する
  nextInt(min, max) {
    const r = Math.abs(this.next());
    return min + (r % (max + 1 - min));
  }
}

function marker(leftTop) {
  let offsetX = leftTop ? 2 : 0;
  let offsetY = leftTop ? 2 : 0;

  let markerImg = new Jimp(2 * scale - 2, 2 * scale - 2, "#000000");
  return markerImg.composite(new Jimp(2 * scale - 4, 2 * scale - 4, "#FFFFFF"), offsetX, offsetY);
}

function resetSize() {
  max_longer_edge = parseInt(resultImageSize.value);
  baseHeight = max_longer_edge;
  baseWidth = Math.round(max_longer_edge * shorterEdgeRatio);

  if (radioOrientation.value == "landscape") {
      [baseHeight, baseWidth] = [baseWidth, baseHeight];
  }

  for (let i = 0; i < 4; i++) {
      fileInput[i].value = '';
      imgPreview[i].src = '';
      jimpImages[i] = null;
  }
  button01.setAttribute("disabled", true);
  button02.setAttribute("disabled", true);
  resultImagePreview.forEach(img => {
      img.src = '';
  });
  resultImageBox.forEach(box => {
      box.style.setProperty('width', `${baseWidth * 2}px`);
      box.style.setProperty('height', `${baseHeight * 2 + 4}px`);
  });
}

function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {

    // Pick a remaining element.
    randomIndex = random.nextInt(0, currentIndex - 1);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

function floydSteinberg(jimpImage) {
  let width = jimpImage.bitmap.width;
  let height = jimpImage.bitmap.height;
  let grayArray = new Array(height);
  for (let i = 0; i < height; i++) {
      grayArray[i] = new Array(width);
  }
  jimpImage.scan(0, 0, width, height, function (x, y, idx) {
      let red = this.bitmap.data[idx + 0];
      let green = this.bitmap.data[idx + 1];
      let blue = this.bitmap.data[idx + 2];
      grayArray[y][x] = (red + green + blue) / 3;
  });
  let resultImage = jimpImage.clone();
  resultImage.scan(0, 0, width, height, function (x, y, idx) {
      let gray = grayArray[y][x];
      let new_color = 0;

      if (gray > 127.5) {
          new_color = 255;
      }

      let err = (gray - new_color) / 16;
      if (x < width - 1) {
          grayArray[y][x + 1] += err * 7;
      }
      if (y < height - 1) {
          if (x > 0) {
              grayArray[y + 1][x - 1] += err * 3;
          }
          grayArray[y + 1][x] += err * 5;
          if (x < width - 1) {
              grayArray[y + 1][x + 1] += err;
          }
      }
      this.bitmap.data[idx + 0] = new_color;
      this.bitmap.data[idx + 1] = new_color;
      this.bitmap.data[idx + 2] = new_color;
  });
  return resultImage;
}

async function drawPreview(target) {
  if (!jimpImages[target]) {
      return
  }
  previewJimpImage = jimpImages[target].clone();
  previewJimpImage
  .getBase64(Jimp.AUTO, (err, src) => {
          if (err) throw err;
          imgPreview[target].src = src;
  });
}

async function loadImage() {
  let target = this.target
  imgPreview[target].src = '';
  loadingArea[target].style.setProperty('width', `${baseWidth}px`);
  loading[target].style.display = 'block';

  let data = fileInput[target].files[0];

  const url =URL.createObjectURL(data);
  Jimp.read(url).then(jimpImage => {
      jimpImages[target] = jimpImage
          .composite(new Jimp(jimpImage.bitmap.width, jimpImage.bitmap.height, "#FFFFFF"), 0, 0, {mode: Jimp.BLEND_DESTINATION_OVER})
          .background(0xFFFFFFFF )
          .contain(baseWidth, baseHeight, Jimp.HORIZONTAL_ALIGN_CENTER | Jimp.VERTICAL_ALIGN_MIDDLE, Jimp.RESIZE_NEAREST_NEIGHBOR)
          .opaque()
          .scan(0, 0, baseWidth, baseHeight, function (x, y, idx) {
            const grey = Math.round(
                0.2126 * this.bitmap.data[idx] +
                  0.7152 * this.bitmap.data[idx + 1] +
                  0.0722 * this.bitmap.data[idx + 2]
              );
        
            this.bitmap.data[idx] = grey;
            this.bitmap.data[idx + 1] = grey;
            this.bitmap.data[idx + 2] = grey;
        });
      jimpImages[target] = floydSteinberg(jimpImages[target]);
      drawPreview(target);
  })
  .catch(err => {
      console.error(err);
  }).finally(() => {
      loading[target].style.display = 'none';
      URL.revokeObjectURL(url);
      if (jimpImages[0] && jimpImages[1] && jimpImages[2] && jimpImages[3]) {
          button01.removeAttribute("disabled");
      }
  });
}

function bwHex(white) {
  if (white) {
      return 0xffffffff;
  } else {
      return 0x000000ff;
  }
}

function chooseNextBlock(currentBlock, nextIsWhite, targetIsWhite) {
  let nextBlockCandidates = [];
  let nextBlock = [];
  let previewBlock = [];
  if (nextIsWhite) {
      nextBlockCandidates = [
          [true, true, false, false],
          [true, false, true, false],
          [true, false, false, true],
          [false, true, true, false],
          [false, true, false, true],
          [false, false, true, true]
      ];
  } else {
      nextBlockCandidates = [
          [true, false, false, false],
          [false, true, false, false],
          [false, false, true, false],
          [false, false, false, true]
      ];
  }
  shuffle(nextBlockCandidates);
  for (let i = 0; i < nextBlockCandidates.length; i++) {
      nextBlock = nextBlockCandidates[i];
      previewBlock = [
          currentBlock[0] && nextBlock[0],
          currentBlock[1] && nextBlock[1],
          currentBlock[2] && nextBlock[2],
          currentBlock[3] && nextBlock[3]
      ];
      let trueCount = previewBlock.filter(Boolean).length;
      if ((targetIsWhite && trueCount == 1) || (!targetIsWhite && trueCount == 0)) {
          break;
      }
  }
  return [nextBlock, previewBlock]
}

async function composite() {
  firstTime = false;
  resultImagePreview1.src = '';
  resultImagePreview.forEach(img => {
    img.src = '';
  });
  resultLoadingArea.forEach(area => {
    area.style.setProperty('width', `${2 * baseWidth}px`);
  });
  resultLoading.forEach(area => {
    area.style.display = 'block';
  });
  random = new Random(seed);
  if (!jimpImages[0] || !jimpImages[1] || !jimpImages[2] || !jimpImages[3]) {
      return;
  }

  let resultBase1 = new Jimp(2 * baseWidth, 2 * baseHeight);
  let resultBase2 = new Jimp(2 * baseWidth, 2 * baseHeight);
  let resultBase3 = new Jimp(2 * baseWidth, 2 * baseHeight);
  let resultBase4 = new Jimp(2 * baseWidth, 2 * baseHeight);
  jimpImages[0].scan(0, 0, baseWidth, baseHeight, function (x, y, idx) {
    let w1 = this.bitmap.data[idx + 0] > 0;
    let w2 = jimpImages[1].getPixelColor(x, y) > 0x0000ff;
    let w3 = jimpImages[2].getPixelColor(x, y) > 0x0000ff;
    let idxList = [
      [2 * x, 2 * y],
      [2 * x + 1, 2 * y],
      [2 * x, 2 * y + 1],
      [2 * x + 1, 2 * y + 1]
    ]

    let nextIdxList = [
      [2 * x + 2, 2 * y],
      [2 * x + 3, 2 * y],
      [2 * x + 2, 2 * y + 1],
      [2 * x + 3, 2 * y + 1]
    ]

    let previousBlock = [];
    if (x == 0) {
        let result2 = [false, false, w2, true];
        shuffle(result2);
        for (let i = 0; i < 4; i++) {
            resultBase2.setPixelColor(bwHex(result2[i]), idxList[i][0], idxList[i][1]);
        }
        previousBlock = result2;
    } else {
        previousBlock = [
            resultBase2.getPixelColor(2 * x, 2 * y) > 0x0000ff,
            resultBase2.getPixelColor(2 * x + 1, 2 * y) > 0x0000ff,
            resultBase2.getPixelColor(2 * x, 2 * y + 1) > 0x0000ff,
            resultBase2.getPixelColor(2 * x + 1, 2 * y + 1) > 0x0000ff
        ]
    }

    let nextResult = chooseNextBlock(previousBlock, w1, w3);
    let result1 = nextResult[0];
    let result3 = nextResult[1];
    for (let i = 0; i < 4; i++) {
        resultBase1.setPixelColor(bwHex(result1[i]), idxList[i][0], idxList[i][1]);
        resultBase3.setPixelColor(bwHex(result3[i]), idxList[i][0], idxList[i][1]);
    }

    if (x < baseWidth - 1) {
        let w2Next = jimpImages[1].getPixelColor(x + 1, y) > 0x0000ff;
        let w4 = jimpImages[3].getPixelColor(x + 1, y) > 0x0000ff;
        nextResult = chooseNextBlock(result1, w2Next, w4);
        let result2Next = nextResult[0];
        let result4 = nextResult[1];
        for (let i = 0; i < 4; i++) {
            resultBase2.setPixelColor(bwHex(result2Next[i]), nextIdxList[i][0], nextIdxList[i][1]);
            resultBase4.setPixelColor(bwHex(result4[i]), nextIdxList[i][0], nextIdxList[i][1]);
        }
    }
  });
  resultBase1.getBuffer('image/png', (err, buffer) => {
      if (err) throw err;
      resultDataList[0] = new Blob([buffer], {
          type: 'image/png'
      });
  });
  resultBase2.getBuffer('image/png', (err, buffer) => {
      if (err) throw err;
      resultDataList[1] = new Blob([buffer], {
          type: 'image/png'
      });
  });
  resultBase3.getBuffer('image/png', (err, buffer) => {
      if (err) throw err;
      resultDataList[2] = new Blob([buffer], {
          type: 'image/png'
      });
  });
  resultBase4.getBuffer('image/png', (err, buffer) => {
      if (err) throw err;
      resultDataList[3] = new Blob([buffer], {
          type: 'image/png'
      });
  });
  resultBase1.resize(scale * 2 * baseWidth, scale * 2 * baseHeight, Jimp.RESIZE_NEAREST_NEIGHBOR)
  .background(0xFFFFFFFF )
  .contain(scale * 2 * baseWidth, scale * 2 * (baseHeight + 2), Jimp.HORIZONTAL_ALIGN_CENTER | Jimp.VERTICAL_ALIGN_MIDDLE, Jimp.RESIZE_NEAREST_NEIGHBOR)
  .composite(leftTopMarker, 0, 0)
  .composite(rightDownMarker, scale * 2 * baseWidth - 2 * scale + 2, scale * 2 * (baseHeight + 1) + 2)
  .composite(rightDownMarker, scale * 2 * baseWidth - 4 * scale + 2, scale * 2 * (baseHeight + 1) + 2)
  .getBase64(Jimp.MIME_PNG, (err, src) => {
      resultLoading.forEach(area => {
        area.style.display = 'none';
      });
      if (err) throw err;
      resultImagePreview1.src = src;
      resultImagePreview1.style.setProperty('width', `${2 * baseWidth}px`);
  });
  resultBase2.resize(scale * 2 * baseWidth, scale * 2 * baseHeight, Jimp.RESIZE_NEAREST_NEIGHBOR)
  .background(0xFFFFFFFF )
  .contain(scale * 2 * baseWidth, scale * 2 * (baseHeight + 2), Jimp.HORIZONTAL_ALIGN_CENTER | Jimp.VERTICAL_ALIGN_MIDDLE, Jimp.RESIZE_NEAREST_NEIGHBOR)
  .composite(leftTopMarker, 0, 0)
  .composite(leftTopMarker, 2 * scale, 0)
  .composite(rightDownMarker, scale * 2 * baseWidth - 2 * scale + 2, scale * 2 * (baseHeight + 1) + 2)
  .getBase64(Jimp.MIME_PNG, (err, src) => {
      if (err) throw err;
      resultImagePreview2.src = src;
      resultImagePreview2.style.setProperty('width', `${2 * baseWidth}px`);
  });
  resultBase3.getBase64(Jimp.MIME_PNG, (err, src) => {
      if (err) throw err;
      resultImagePreview3.src = src;
      resultImagePreview3.style.setProperty('width', `${2 * baseWidth}px`);
  });
  resultBase4.getBase64(Jimp.MIME_PNG, (err, src) => {
    if (err) throw err;
    resultImagePreview4.src = src;
    resultImagePreview4.style.setProperty('width', `${2 * baseWidth}px`);
  });
  button02.removeAttribute("disabled");

}

function getPresignedUrl() {
  let mimeType = 'image/png';
  httpRequest.onreadystatechange = setPresignedUrl
  httpRequest.open("GET", presignedUrlEndpoint + '?' + 'mime_type=' + encodeURIComponent(mimeType) + '&vc_type=' + vcType);
  httpRequest.send();

}

function setPresignedUrl() {
  if (httpRequest.readyState === XMLHttpRequest.DONE) {
      if (httpRequest.status === 200) {
          responseBody = JSON.parse(httpRequest.responseText);
          presignedUrls = responseBody["urls"];
          imageId = responseBody["image_id"];
          if (presignedUrls.length == numFilesToUpload) {
              uploadFiles(presignedUrls);
          } else {
              console.log("invalid response");
          }
      } else {
          alert(httpRequest.status)
      }
  }
}

function moveToNextPage() {
  window.location.href = `${linkUrlBase}?image_code=${imageId}`;
}

function uploadFiles() {
    if (presignedUrls.length == 0) {
        moveToNextPage();
        return;
    }
    index = numFilesToUpload - presignedUrls.length;
    let first = presignedUrls.shift();
    let url = first["url"];
    let fields = first["fields"];
    let data = resultDataList[index];
    httpRequest.abort();
    httpRequest.onreadystatechange = uploadFileAgain;
    httpRequest.open("POST", url, true);
    fd = new FormData();
    fd.append('Content-Type', fields['Content-Type']);
    fd.append('key', fields['key']);
    fd.append('AWSAccessKeyId', fields['AWSAccessKeyId']);
    fd.append('x-amz-security-token', fields['x-amz-security-token']);
    fd.append('policy', fields['policy']);
    fd.append('signature', fields['signature']);
    fd.append('file', data);
    httpRequest.send(fd);
}

function uploadFileAgain() {
    if (httpRequest.readyState === XMLHttpRequest.DONE) {
        if (httpRequest.status === 204) {
            uploadFiles();
        } else {
            alert(httpRequest.status);
        }
    }
}

// Google Ad
window.googletag = window.googletag || { cmd: [] };
let rewardedSlot;
let rewardPayload;

googletag.cmd.push(() => {
  rewardedSlot = googletag.defineOutOfPageSlot(
    // "/22639388115/rewarded_web_example",
    "/23011943505/kirie_unit01",
    googletag.enums.OutOfPageFormat.REWARDED,
  );

  // Slot returns null if the page or device does not support rewarded ads.
  if (rewardedSlot) {
    rewardedSlot.addService(googletag.pubads());

    googletag.pubads().addEventListener("rewardedSlotReady", (event) => {
      updateStatus("Rewarded ad slot is ready.");

      document.getElementById("watchAdButton").onclick = () => {
        event.makeRewardedVisible();
        displayModal();
        updateStatus("Rewarded ad is active.");
      };

      button01.addEventListener("click", (event) => {
        if (firstTime) {
            displayModal("reward", "重ねる絵の生成には広告動画の閲覧が必要です。閲覧しますか？ Watch an ad to create transparent image?");
        } else {
            composite();
        }
      });
    });

    googletag.pubads().addEventListener("rewardedSlotClosed", dismissRewardedAd);

    googletag.pubads().addEventListener("rewardedSlotGranted", (event) => {
      rewardPayload = event.payload;
      updateStatus("Reward granted.");
    });

    googletag.pubads().addEventListener("slotRenderEnded", (event) => {
      if (event.slot === rewardedSlot && event.isEmpty) {
        updateStatus("No ad returned for rewarded ad slot.");
        firstTime = false;
        button01.addEventListener("click", (event) => {
          composite();
        });
      }
    });

    googletag.enableServices();
    googletag.display(rewardedSlot);
  } else {
    updateStatus("Rewarded ads are not supported on this page.");
  }
});

function dismissRewardedAd() {
  if (rewardPayload) {
    // User was granted a reward and closed the ad.
    displayModal(
      "grant",
      `You have been rewarded ${rewardPayload.amount} ${rewardPayload.type}!`,
    );
    rewardPayload = null;
    composite();
  } else {
    // User closed the ad without getting a reward.
    updateStatus("Rewarded ad has been closed without getting a reward.");
    displayModal();
  }

  updateStatus("Rewarded ad has been closed.");

  if (rewardedSlot) {
    googletag.destroySlots([rewardedSlot]);
  }
}

function displayModal(type = "", message = "") {
  const modal = document.getElementById("modal");
  modal.removeAttribute("data-type");

  if (type) {
    document.getElementById("modalMessage").textContent = message;
    modal.setAttribute("data-type", type);
  }
}

function updateStatus(message) {
  console.log(message);
}
